/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type InvoicesListVariant = typeof InvoicesListVariant[keyof typeof InvoicesListVariant];


export const InvoicesListVariant = {
  default: 'default',
  form: 'form',
  table: 'table',
} as const;
